import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { faPlus } from '@fortawesome/pro-regular-svg-icons';
import * as yup from 'yup';
import Group from '../../../../../components/form/elements/group';
import {
  date,
  dealType,
  makeButton,
  renderDealTable,
  renderLostRadioGroup,
} from '../form-parts';
import Text from '../../../../../components/form/elements/text';
import { useWarehouseContext } from '../warehouse-context';
import TextArea from '../../../../../components/form/elements/text-area';
import DealTypes from '../../../../../enums/deal-type';
import Hidden from '../../../../../components/form/elements/hidden';
import css from './lost.module.css';

export function useLostForm(mode) {
  const { t } = useTranslation();
  const { setIsOpen } = useWarehouseContext();

  const handleClick = () => {
    setIsOpen(true);
  };

  const [form] = useState(() => [
    Group(
      [
        Group(
          [
            dealType(t, true),
            date(true),
            Text(
              'purchase_document_number',
              'pages.warehouse.deals.purchase_document_number',
              null,
              null,
              true
            ),
          ],
          null,
          false,
          false,
          true,
          css['form_body_top_group_top']
        ),
        Group(
          [renderLostRadioGroup()],
          null,
          false,
          false,
          true,
          css['form_body_top_group_bottom']
        ),
      ],
      null,
      false,
      false,
      false,
      css['form_body_top']
    ),
    Hidden('products_exists'),
    Group([
      mode === 'view'
        ? () => null
        : makeButton(
            'pages.warehouse.products.add-product',
            'pink-button',
            '',
            faPlus,
            false,
            handleClick
          ),
    ]),
    Group(
      [renderDealTable(mode)],
      null,
      false,
      false,
      true,
      css['table-container']
    ),
    Group([
      TextArea('comment', 'pages.warehouse.deals.notes', 2, true, 'full-width'),
    ]),
  ]);

  return form;
}

export const lostSchema = () => {
  return yup.object().shape({
    type: yup.object().shape({
      value: yup.string().required(),
    }),
    date: yup.date().required(),
    subtype: yup
      .string()
      .required()
      .oneOf([DealTypes.lost, DealTypes.leftover]),
    comment: yup.string().max(4000).nullable(),
    products_exists: yup.bool().required(),
  });
};
